import { render, staticRenderFns } from "./PageUtil.vue?vue&type=template&id=bd45f4d4"
import script from "./PageUtil.vue?vue&type=script&lang=js"
export * from "./PageUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports